import React, { useState } from "react";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import { AddUserPostApi } from "../../../../Api/PanelAdminServices";
import Style from "./AddSupplierContainer.module.scss";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import "./AddSupplier.css";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
const AddSupplierContainer = () => {
  const [ontimeLogo, setOntimeLogo] = useState("");
  const [ontimeCover, setOntimeCover] = useState("");
  const [photo, setPhoto] = useState("");
  const [type, setType] = useState();
  const [chooseCity, setChooseCity] = useState();
  const [disable, setDisable] = useState(false);
  const data = [
    {
      value: "1",
      label: "رستوران",
      type: "food",
    },
    {
      value: "2",
      label: "فروشگاه",
      type: "supermarket",
    },
  ];
  const city = [
    {
      value: "1",
      label: "بهشهر",
      cityId: "4851",
    },
    {
      value: "2",
      label: "گلوگاه",
      cityId: "4861",
    },
    {
      value: "3",
      label: "نکا",
      cityId: "4841",
    },
  ];
  //////آپلود کردن عکس پس زمینه
  const UploadCover = async (image) => {
    return await resizeFile(image);
  };
  /////ریسایز کردن cover برای آپلود
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setOntimeCover(uri);
        },
        "base64"
      );
    });
  //////آپلود کردن عکس لوگو
  const UploadLogo = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setOntimeLogo(uri);
        },
        "base64"
      );
    });

  //////آپلود کردن عکس
  const UploadPhoto = async (image) => {
    return await resizeFilePhoto(image);
  };
  /////ریسایز کردن photo برای آپلود
  const resizeFilePhoto = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onsubmit = (data) => {
    setDisable(true);
    let info = {
      first_name: data.name,
      last_name: data.lName,
      phone: data.phone?data.phone:"0",
      phone_2: data.phone2?data.phone2:null,
      phone_3: data.phone3?data.phone3:null,
      national_code: data.nationalcode,
      type: type.type,
      name: data.supplierName,
      address: data.address,
      user_type: "supplier",
      logo: ontimeLogo,
      cover: ontimeCover,
      photo: data.photo,
      city_id: chooseCity.cityId,
      lat: "",
      lon: "",
      about_us: "",
      email: data.email ? data.email : "",
      telephone: data.telephone ? data.telephone : "0",
      min_cart: data.mincart ? data.mincart : "0",
      fee: data.fee?data.fee:"0",
      packed_product_fee:data.packed?data.packed:"0",
    };
    AddUserPostApi(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
        setDisable(false);
      } else {
        errorToast(res.message);
        setDisable(false);
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"افزودن تامین کننده "} />
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          <section className={Style.uploadBackground}>
            <div className={Style.uploadTitle}>آپلود تصویر پس زمینه</div>
            <div className={Style.uploadPart}>
              <img src={ontimeCover} alt="" />
            </div>
            <div className={Style.imageUpload}>
              <h3 className={Style.title}>بارگذاری تصویر</h3>
              <input
                id={"uploadBack"}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => UploadCover(e.target.files[0])}
              />
              <label htmlFor={"uploadBack"} className={Style.iconHolder}>
                <FontAwesomeIcon className={Style.icon} icon={faImage} />
              </label>
            </div>
          </section>
          <div style={{ display: "flex", width: "94%" }}>
            <section className={Style.logoPart}>
              <div className={Style.titleLogo}>بارگذاری لوگو</div>
              <div className={Style.uploadImage}>
                <img src={ontimeLogo} alt="" />
              </div>
              <input
                id={"uploadLogo"}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => UploadLogo(e.target.files[0])}
              />
              <label htmlFor={"uploadLogo"} className={Style.iconHolder}>
                <FontAwesomeIcon className={Style.icon} icon={faImage} />
              </label>
              <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
            </section>

            <section className={Style.logoPart}>
              <div className={Style.titleLogo}>بارگذاری عکس تامین کننده</div>
              <div className={Style.uploadImage}>
                <img src={photo} alt="" />
              </div>
              <input
                id={"uploadPhoto"}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => UploadPhoto(e.target.files[0])}
              />
              <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
                <FontAwesomeIcon className={Style.icon} icon={faImage} />
              </label>
              <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
            </section>
          </div>
          {/* <div className={Style.mapBtnHolder}>
            <button
              onClick={() => setShowmodalState(true)}
              className={Style.mapBtn}
            >
              افزودن آدرس در نقشه
            </button>
          </div> */}

          <input
            className={errors.name ? Style.errorInput : Style.inputPart}
            placeholder={"نام"}
            {...register("name", { required: true })}
          />

          <input
            className={errors.lName ? Style.errorInput : Style.inputPart}
            placeholder={"نام خانوادگی "}
            {...register("lName", { required: true })}
          />

          <Select
            onChange={setType}
            options={data}
            placeholder={"نوع تامین کننده"}
            className={Style.selectPart}
          />

          <input
            className={errors.fee ? Style.errorInput : Style.inputPart}
            placeholder={"کمیسیون"}
            {...register("fee")}
          />
          {type&&type.type === "food" ? (
            <input
              className={errors.packed ? Style.errorInput : Style.inputPart}
              placeholder={"کمیسیون محصولات بسته بندی"}
              {...register("packed")}
            />
          ) : null}

          <input
            className={errors.phone ? Style.errorInput : Style.inputPart}
            placeholder={"شماره همراه"}
            {...register("phone", { required: true })}
          />
          <input
            className={Style.inputPart}
            placeholder={"شماره همراه دوم"}
            {...register("phone2")}
          />
          <input
            className={Style.inputPart}
            placeholder={"شماره همراه سوم"}
            {...register("phone3")}
          />

          <input
            className={Style.inputPart}
            placeholder={"شماره تلفن"}
            {...register("telephone")}
          />

          <input
            className={Style.inputPart}
            placeholder={"ایمیل "}
            {...register("email")}
          />

          <input
            className={errors.nationalcode ? Style.errorInput : Style.inputPart}
            placeholder={"کدملی "}
            {...register("nationalcode", { required: true })}
          />

          {/* <input
            className={errors.cityId ? Style.errorInput : Style.inputPart}
            placeholder={"ایدی شهر "}
            {...register("cityId", { required: true })}
          /> */}
          <Select
            onChange={setChooseCity}
            options={city}
            placeholder={" شهر"}
            className={Style.selectPart}
          />

          <input
            className={errors.supplierName ? Style.errorInput : Style.inputPart}
            placeholder={"نام فروشگاه یا رستوران"}
            {...register("supplierName", { required: true })}
          />
          <input
            className={Style.inputPart}
            placeholder={"حداقل قیمت سبد خرید"}
            {...register("mincart")}
          />
          {/* lat na lon "" */}
          <textarea
            className={
              errors.address ? Style.errorTextareaPart : Style.textareaPart
            }
            placeholder={"آدرس"}
            {...register("address", { required: true })}
          />
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            اضافه کردن
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSupplierContainer;
